"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6770],{

/***/ 11053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ list_chart; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(32016);
// EXTERNAL MODULE: ./node_modules/base-64/base64.js
var base64 = __webpack_require__(97501);
var base64_default = /*#__PURE__*/__webpack_require__.n(base64);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(15313);
// EXTERNAL MODULE: ./src/redux/action/aggr.js
var aggr = __webpack_require__(49888);
// EXTERNAL MODULE: ./src/redux/action/csv.js
var csv = __webpack_require__(63383);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var reselect_es = __webpack_require__(68697);
// EXTERNAL MODULE: ./src/lib/format-currency.js
var format_currency = __webpack_require__(70351);
// EXTERNAL MODULE: ./src/translations/index.js + 4 modules
var translations = __webpack_require__(99408);
// EXTERNAL MODULE: ./src/redux/reselect/config.js
var config = __webpack_require__(57708);
;// CONCATENATED MODULE: ./src/redux/reselect/top-chart.js
/* eslint-disable camelcase */ 



var selectPayloadByKey = (0,reselect_es/* createSelector */.P1)(function(state) {
    return state.aggr.payload;
}, function(_, key) {
    return key;
}, function(payload, key) {
    return payload[key];
});
var selectTopLine = (0,reselect_es/* createSelector */.P1)(selectPayloadByKey, config/* default */.ZP, function(payload, config) {
    var languageCode = config.languageCode;
    if (!payload || !payload.data) return [];
    var currency = payload.currency, query = payload.query, _data = payload.data, _aggregations = _data.aggregations, buckets = _aggregations.results.buckets;
    var isUsage = query.includes("usage_data");
    var currentTotal = 0;
    var durationTotal = 0;
    buckets.forEach(function(data) {
        var _current_period = data.current_period, value = _current_period.total_revenues.value, _total_duration = _current_period.total_duration, valueDuration = _total_duration.value;
        currentTotal += value;
        durationTotal += valueDuration;
    });
    return buckets.map(function(data) {
        var title = data.key, current_period = data.current_period, previous_period = data.previous_period;
        var totalCurrentRevenues = (0,format_currency/* default */.Z)(currency, current_period.total_revenues.value);
        var totalPreviousRevenues = (0,format_currency/* default */.Z)(currency, previous_period.total_revenues.value);
        var totalCurrentDuration = "".concat(parseFloat(current_period.total_duration.value / 60).toFixed(1), " ").concat(translations/* default */.Z[languageCode].hours);
        var totalPreviousDuration = "".concat(parseFloat(previous_period.total_duration.value / 60).toFixed(1), " ").concat(translations/* default */.Z[languageCode].hours);
        var percentEarning = 0;
        if (previous_period.total_revenues.value !== 0) {
            percentEarning = Math.round((current_period.total_revenues.value - previous_period.total_revenues.value) / previous_period.total_revenues.value * 100);
        }
        var percentTrend = 0;
        if (previous_period.total_duration.value !== 0) {
            percentTrend = Math.round((current_period.total_duration.value - previous_period.total_duration.value) / previous_period.total_duration.value * 100);
        }
        var percent = 0;
        if (currentTotal > 0) percent = Math.round(current_period.total_revenues.value * 100 / currentTotal);
        var percentDuration = 0;
        if (durationTotal > 0) percentDuration = Math.round(current_period.total_duration.value * 100 / durationTotal);
        return {
            title: title,
            unformattedRevenues: current_period.total_revenues.value,
            unformattedDuration: current_period.total_duration.value,
            totalCurrentRevenues: totalCurrentRevenues,
            totalPreviousRevenues: totalPreviousRevenues,
            totalCurrentDoc: current_period.doc_count,
            totalCurrentQuantity: current_period.total_quantity.value,
            totalPreviousQuantity: previous_period.total_quantity.value,
            totalCurrentDuration: totalCurrentDuration,
            totalPreviousDuration: totalPreviousDuration,
            percentEarning: percentEarning,
            percent: percent,
            percentTrend: percentTrend,
            percentDuration: percentDuration
        };
    }).sort(function(a, b) {
        return !isUsage ? a.unformattedRevenues - b.unformattedRevenues : a.unformattedDuration - b.unformattedDuration;
    }).reverse();
});
/* harmony default export */ var top_chart = (selectTopLine);

// EXTERNAL MODULE: ./src/theme/content-loader/index.js
var content_loader = __webpack_require__(52005);
// EXTERNAL MODULE: ./src/theme/empty-data/index.js + 1 modules
var empty_data = __webpack_require__(40372);
// EXTERNAL MODULE: ./src/theme/buttons/btn-link.js
var btn_link = __webpack_require__(25733);
// EXTERNAL MODULE: ./src/theme/icons/filetype-xlsx.js
var filetype_xlsx = __webpack_require__(29651);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js
var dist_index_esm = __webpack_require__(50056);
// EXTERNAL MODULE: ./src/theme/charts/colors.js
var colors = __webpack_require__(1778);
;// CONCATENATED MODULE: ./src/theme/charts/line/index.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  display: flex;\n  position: relative;\n  height: 8px;\n  border-bottom-left-radius: 3px;\n  border-bottom-right-radius: 3px;\n\n  :after {\n    content: ' ';\n    position: absolute;\n    top: 0px;\n    background-color: ",
        ";\n    height: 8px;\n    width: ",
        "%;\n    border-bottom-left-radius: 3px;\n    border-bottom-right-radius: 3px;\n\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4190790-0"
})(_templateObject(), index_esm/* color */.$_, index_esm/* space */.Dh, function(param) {
    var colorLine = param.colorLine;
    return (0,dist_index_esm/* themeGet */.R)("colors.".concat(colorLine));
}, function(param) {
    var percent = param.percent;
    return percent;
}, index_esm/* border */.Cg);
function line(param) {
    var className = param.className, percent = param.percent, defaultColor = param.defaultColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        className: className,
        bg: "primary_100",
        colorLine: defaultColor,
        percent: percent
    });
}

// EXTERNAL MODULE: ./src/theme/text/index.js
var theme_text = __webpack_require__(5799);
// EXTERNAL MODULE: ./src/theme/icons/history.js
var icons_history = __webpack_require__(87504);
;// CONCATENATED MODULE: ./src/components/top-line-charts/list-chart/row.js
/* eslint-disable no-nested-ternary */ 
function row_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  height: 83px;\n"
    ]);
    row_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  align-items: center;\n\n  & > .row {\n    height: 75px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    flex: 1;\n    gap: ",
        "px;\n    min-width: 0;\n    padding: ",
        "px ",
        "px;\n\n    & > .left {\n      min-width: 0;\n      max-width: 55%;\n      overflow: hidden;\n    }\n\n    .small {\n      max-width: 200px;\n    }\n\n    @media (min-width: ",
        ") {\n      padding: ",
        "px ",
        "px;\n\n      & > .left {\n        max-width: 380px;\n      }\n    }\n\n    & > .right {\n      & > .right-row {\n        display: flex;\n        flex-direction: row;\n        justify-content: flex-end;\n      }\n\n      & > .previous-revenues {\n        display: flex;\n        flex-direction: row;\n        justify-content: flex-end;\n\n        & > p {\n          padding-right: ",
        "px;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  height: ",
        "px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  /* stylelint-disable */\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  /* stylelint-enable */\n  -webkit-line-clamp: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}










var row_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ac3a01f3-0"
})(row_templateObject());
var Flex = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ac3a01f3-1"
})(_templateObject1());
var Card = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ac3a01f3-2"
})(_templateObject2(), (0,dist_index_esm/* themeGet */.R)("space.xs"), (0,dist_index_esm/* themeGet */.R)("space.s"), (0,dist_index_esm/* themeGet */.R)("space.s"), (0,dist_index_esm/* themeGet */.R)("breakpoints.0"), (0,dist_index_esm/* themeGet */.R)("space.s"), (0,dist_index_esm/* themeGet */.R)("space.m"), (0,dist_index_esm/* themeGet */.R)("space.s"));
var WrapIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-ac3a01f3-3"
})(_templateObject3(), index_esm/* color */.$_);
var Value = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ac3a01f3-4"
})(_templateObject4(), index_esm/* color */.$_, index_esm/* space */.Dh);
var TextEllipsis = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-ac3a01f3-5"
})(_templateObject5(), index_esm/* typography */.cp, index_esm/* color */.$_, index_esm/* space */.Dh, function(param) {
    var line = param.line;
    return line * 22;
}, function(param) {
    var line = param.line;
    return line;
});
function Row(param) {
    var payload = param.payload, index = param.index, languageCode = param.languageCode, dataType = param.dataType, size = param.size, _color = param.color, _$color = _color === void 0 ? "store_name" : _color, _noPrevious = param.noPrevious, noPrevious = _noPrevious === void 0 ? false : _noPrevious;
    var colorLine = (0,react.useMemo)(function() {
        return colors/* default */.Z[_$color][index % 6];
    }, [
        index
    ]);
    var isUsage = dataType === "usage_data";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(row_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
                colorLine: colorLine,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                        fontSize: "display",
                        lineHeight: "display",
                        fontWeight: "medium",
                        ml: "m",
                        children: index + 1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "left ".concat(size === "small" && "small"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(theme_text/* default */.Z, {
                                                fontSize: "h3",
                                                lineHeight: "h3",
                                                fontWeight: "bold",
                                                ml: "xs",
                                                color: colorLine,
                                                children: [
                                                    isUsage ? isNaN(payload.percentDuration) ? 0 : payload.percentDuration : isNaN(payload.percent) ? 0 : payload.percent,
                                                    "%"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextEllipsis, {
                                                fontSize: "h3",
                                                lineHeight: "h3",
                                                fontWeight: "bold",
                                                line: "1",
                                                ml: "xs",
                                                children: payload.title
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                        fontSize: "pSmall",
                                        lineHeight: "pSmall",
                                        fontWeight: "bold",
                                        ml: "xs",
                                        color: colorLine,
                                        children: "".concat(isUsage ? payload.totalCurrentDuration : payload.totalCurrentRevenues, " (").concat(payload.totalCurrentQuantity, " ").concat(translations/* default */.Z[languageCode].units, ")")
                                    })
                                ]
                            }),
                            !noPrevious && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "right",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "right-row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                                fontSize: "label",
                                                lineHeight: "label",
                                                fontWeight: "normal",
                                                mr: "xs",
                                                children: translations/* default */.Z[languageCode].previous_period
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapIcon, {
                                                color: colorLine,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_history/* default */.Z, {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "previous-revenues",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                                fontSize: "label",
                                                lineHeight: "label",
                                                fontWeight: "bold",
                                                color: "grey_400",
                                                children: isUsage ? payload.totalPreviousDuration : payload.totalPreviousRevenues
                                            }),
                                            isUsage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                                    fontSize: "label",
                                                    lineHeight: "label",
                                                    fontWeight: "bold",
                                                    color: payload.percentTrend > 0 ? "lime_400" : payload.percentTrend < 0 ? "red_400" : "grey_600",
                                                    textAlign: "right",
                                                    children: "".concat(payload.percentTrend > 0 ? "+" : payload.percentTrend < 0 ? "-" : "", " ").concat(Math.abs(payload.percentTrend), "%")
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                                    fontSize: "label",
                                                    lineHeight: "label",
                                                    fontWeight: "bold",
                                                    color: payload.percentEarning > 0 ? "lime_400" : payload.percentEarning < 0 ? "red_400" : "grey_600",
                                                    textAlign: "right",
                                                    children: "".concat(payload.percentEarning > 0 ? "+" : payload.percentEarning < 0 ? "-" : "", " ").concat(Math.abs(payload.percentEarning), "%")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(line, {
                percent: isUsage ? payload.percentDuration : payload.percent,
                defaultColor: colorLine
            })
        ]
    });
}
/* harmony default export */ var row = (Row);

;// CONCATENATED MODULE: ./src/components/top-line-charts/list-chart/index.js
/* eslint-disable no-nested-ternary */ 
function list_chart_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  overflow-y: auto;\n\n  & > .head {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n  }\n\n  ",
        "\n"
    ]);
    list_chart_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function list_chart_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n\n  ",
        "\n"
    ]);
    list_chart_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}















var list_chart_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d0392a95-0"
})(list_chart_templateObject(), index_esm/* layout */.bK);
var WrapEmpty = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d0392a95-1"
})(list_chart_templateObject1(), index_esm/* color */.$_);
function ListChart(param) {
    var compare = param.compare, term = param.term, dataType = param.dataType, dateFrom = param.dateFrom, dateTo = param.dateTo, dateRange = param.dateRange, filters = param.filters, terms = param.terms, size = param.size, _$color = param.color, reloadChecked = param.reloadChecked, noPrevious = param.noPrevious, topList = param.topList, isAdmin = param.isAdmin;
    var ref = (0,react.useState)(null), queriedKey = ref[0], setQueriedKey = ref[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }), currency = ref1.currency, languageCode = ref1.languageCode;
    var resultPayload = (0,es/* useSelector */.v9)(function(state) {
        return state.aggr.payload[queriedKey];
    });
    var resultTopChart = (0,es/* useSelector */.v9)(function(state) {
        return top_chart(state, queriedKey);
    });
    var analytics_type = (0,es/* useSelector */.v9)(function(state) {
        return state.profile.payload;
    }).analytics_type;
    if (size === "small") resultTopChart = resultTopChart.slice(0, 5);
    var query = (0,react.useMemo)(function() {
        if (!dataType || !dateTo || !dateFrom) return [];
        var result = "currency=".concat(currency, "&dataType=").concat(dataType, "&term=").concat(term, "&size=100&dateTo=").concat(dateTo, "&dateFrom=").concat(dateFrom, "&dateRange=").concat(dateRange, "&compare=").concat(compare, "&version=7&enterprise=").concat(analytics_type || "standard", "&isAdmin=").concat(isAdmin);
        if (filters) {
            result = "".concat(result, "&filters=").concat(filters);
        }
        if (terms) {
            result = "".concat(result, "&terms=").concat(terms);
        }
        return result;
    }, [
        term,
        dateTo,
        dateFrom,
        dateRange,
        dataType,
        filters,
        terms,
        currency,
        compare,
        analytics_type,
        isAdmin, 
    ]);
    (0,react.useEffect)(function() {
        var key = base64_default().encode(query);
        setQueriedKey(key);
        dispatch((0,aggr/* getAggrRequest */.js)({
            term: term,
            size: 0,
            key: key,
            query: query,
            currency: currency,
            isAdmin: isAdmin
        }));
    }, [
        dispatch,
        query,
        currency,
        term,
        reloadChecked,
        isAdmin
    ]);
    var handleExportCsv = (0,react.useCallback)(function() {
        dispatch((0,csv/* topLineCsvRequest */.nV)({
            dateFrom: dateFrom,
            dateTo: dateTo,
            currency: currency,
            languageCode: languageCode,
            term: term,
            query: query,
            isAdmin: isAdmin
        }));
    }, [
        dispatch,
        dateFrom,
        dateTo,
        query,
        term,
        currency,
        languageCode,
        isAdmin
    ]);
    var isWaiting = (0,react.useMemo)(function() {
        if (!resultPayload) return true;
        return resultPayload.isWaiting;
    }, [
        resultPayload
    ]);
    var isEmpty = (0,react.useMemo)(function() {
        if (isWaiting) return false;
        return resultTopChart.length === 0;
    }, [
        isWaiting,
        resultTopChart
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(list_chart_Wrapper, {
        maxHeight: isEmpty ? "100%" : "660px",
        children: isWaiting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(content_loader/* default */.Z, {
            width: 470,
            height: 200,
            lines: [
                {
                    x: 0,
                    y: 0,
                    rx: 5,
                    ry: 5,
                    width: 80,
                    height: 12
                },
                {
                    x: 0,
                    y: 20,
                    rx: 5,
                    ry: 5,
                    width: 120,
                    height: 12
                },
                {
                    x: 0,
                    y: 60,
                    rx: 5,
                    ry: 5,
                    width: 300,
                    height: 12
                },
                {
                    x: 0,
                    y: 100,
                    rx: 5,
                    ry: 5,
                    width: 80,
                    height: 12
                },
                {
                    x: 0,
                    y: 120,
                    rx: 5,
                    ry: 5,
                    width: 120,
                    height: 12
                },
                {
                    x: 0,
                    y: 160,
                    rx: 5,
                    ry: 5,
                    width: 300,
                    height: 12
                }, 
            ]
        }) : isEmpty ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapEmpty, {
            bg: "primary_50",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(empty_data/* default */.Z, {
                label: translations/* default */.Z[languageCode]["no available"]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                topList !== "partners" && size !== "small" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "head",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(btn_link/* default */.Z, {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(filetype_xlsx/* default */.Z, {}),
                        label: translations/* default */.Z[languageCode]["Export XLS"],
                        onClick: handleExportCsv
                    })
                }),
                resultTopChart.map(function(payload, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(row, {
                        payload: payload,
                        index: index,
                        languageCode: languageCode,
                        dataType: dataType,
                        size: size,
                        color: _$color,
                        noPrevious: noPrevious
                    }, payload.title);
                })
            ]
        })
    });
}
/* harmony default export */ var list_chart = (ListChart);


/***/ }),

/***/ 60873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ capitalizeFirstLetter; },
/* harmony export */   "i": function() { return /* binding */ formatDateString; }
/* harmony export */ });
var capitalizeFirstLetter = function(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};
var formatDateString = {
    it: "DD MMM",
    pt: "DD MMM",
    de: "DD MMM",
    en: "MMM DD"
};



/***/ }),

/***/ 95718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68697);
/* harmony import */ var translations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99408);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57708);
/* eslint-disable camelcase */ 


/* harmony default export */ __webpack_exports__["Z"] = ((0,reselect__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(function(state) {
    return state.count.payload;
}, function(_, key) {
    return key;
}, _config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, function(payload, key, param) {
    var languageCode = param.languageCode;
    var percent = 0;
    var card = payload[key];
    if (!card || !card.data) return {
        percent: percent,
        value: null
    };
    var _data = card.data, _aggregations = _data.aggregations, current_period = _aggregations.current_period, previous_period = _aggregations.previous_period;
    var currentDuration = parseFloat((current_period.total_duration.value / 60).toFixed(1));
    var previousDuration = parseFloat((previous_period.total_duration.value / 60).toFixed(1));
    percent = 100;
    if (previousDuration !== 0) {
        percent = Math.round((currentDuration - previousDuration) / previousDuration * 100);
    }
    if (previousDuration === 0 && currentDuration === 0) percent = 0;
    return {
        percent: percent,
        value: "".concat(currentDuration, " ").concat(translations__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[languageCode].hours),
        previousValue: "".concat(previousDuration, " ").concat(translations__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[languageCode].hours)
    };
}));


/***/ }),

/***/ 53189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ quantity; }
});

// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./src/translations/index.js + 4 modules
var translations = __webpack_require__(99408);
;// CONCATENATED MODULE: ./src/lib/format-number.js
var formatNumber = function(locale, value) {
    if (locale === "it") {
        return new Intl.NumberFormat("it-IT").format(value);
    }
    return new Intl.NumberFormat("en-US").format(value);
};
/* harmony default export */ var format_number = (formatNumber);

// EXTERNAL MODULE: ./src/redux/reselect/config.js
var config = __webpack_require__(57708);
;// CONCATENATED MODULE: ./src/redux/reselect/quantity.js
/* eslint-disable camelcase */ 



/* harmony default export */ var quantity = ((0,es/* createSelector */.P1)(function(state) {
    return state.count.payload;
}, function(_, key) {
    return key;
}, config/* default */.ZP, function(payload, key, param) {
    var languageCode = param.languageCode;
    var percent = 0;
    var card = payload[key];
    if (!card || !card.data) return {
        percent: percent,
        value: null
    };
    var _data = card.data, _aggregations = _data.aggregations, current_period = _aggregations.current_period, previous_period = _aggregations.previous_period, query = card.query;
    var currentQuantity = current_period.total_quantity.value;
    var previousQuantity = previous_period.total_quantity.value;
    percent = 100;
    if (previousQuantity !== 0) {
        percent = Math.round((currentQuantity - previousQuantity) / previousQuantity * 100);
    }
    if (previousQuantity === 0 && currentQuantity === 0) percent = 0;
    return {
        percent: percent,
        value: "".concat(format_number(languageCode, currentQuantity), " ").concat(query.match(/usage_data/) ? translations/* default */.Z[languageCode].users : translations/* default */.Z[languageCode].qty),
        previousValue: "".concat(format_number(languageCode, previousQuantity), " ").concat(query.match(/usage_data/) ? translations/* default */.Z[languageCode].users : translations/* default */.Z[languageCode].qty)
    };
}));


/***/ }),

/***/ 69575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ area_analytic; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(32016);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js
var dist_index_esm = __webpack_require__(50056);
// EXTERNAL MODULE: ./node_modules/victory-chart/es/victory-chart.js + 5 modules
var victory_chart = __webpack_require__(58843);
// EXTERNAL MODULE: ./node_modules/victory-voronoi-container/es/victory-voronoi-container.js + 2 modules
var victory_voronoi_container = __webpack_require__(16098);
// EXTERNAL MODULE: ./node_modules/victory-tooltip/es/victory-tooltip.js + 1 modules
var victory_tooltip = __webpack_require__(77013);
// EXTERNAL MODULE: ./node_modules/victory-axis/es/victory-axis.js + 1 modules
var victory_axis = __webpack_require__(73091);
// EXTERNAL MODULE: ./node_modules/victory-group/es/victory-group.js + 1 modules
var victory_group = __webpack_require__(54878);
// EXTERNAL MODULE: ./node_modules/victory-line/es/victory-line.js + 2 modules
var victory_line = __webpack_require__(37203);
// EXTERNAL MODULE: ./node_modules/victory-area/es/victory-area.js + 2 modules
var victory_area = __webpack_require__(42371);
// EXTERNAL MODULE: ./src/hooks/index.js
var hooks = __webpack_require__(85480);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(15313);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/theme/icons/history.js
var icons_history = __webpack_require__(87504);
// EXTERNAL MODULE: ./src/translations/index.js + 4 modules
var translations = __webpack_require__(99408);
// EXTERNAL MODULE: ./src/lib/format-currency.js
var format_currency = __webpack_require__(70351);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(54490);
;// CONCATENATED MODULE: ./src/theme/charts/area-analytic/label.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: ",
        ";\n  transform-origin: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var width = 300;
var height = 125;
var Wrapper = styled_components_browser_esm/* default.g.withConfig */.ZP.g.withConfig({
    componentId: "sc-84971e40-0"
})(_templateObject(), function(param) {
    var isRotate = param.isRotate;
    return isRotate ? "rotate(180deg)" : "rotate(0deg)";
}, function(param) {
    var isRotate = param.isRotate;
    return isRotate ? "".concat(width / 2, "px ").concat(height / 2, "px") : "0px 0px";
});
function Label(param) {
    var maxWidth = param.maxWidth, x = param.x, y = param.y, activePoints = param.activePoints, areaData = param.data;
    // Ensure maxWidth is a valid finite number
    var validMaxWidth = typeof maxWidth === "number" && Number.isFinite(maxWidth) && maxWidth > 0 ? maxWidth : 800;
    var isRotate = (0,react.useMemo)(function() {
        // Ensure x is also valid
        var validX = typeof x === "number" && Number.isFinite(x) ? x : 0;
        return validX > validMaxWidth / 2;
    }, [
        x,
        validMaxWidth
    ]);
    var theme = (0,react.useContext)(styled_components_browser_esm/* ThemeContext */.Ni);
    var getLabel = (0,react.useCallback)(function(color) {
        var el = areaData.find(function(row) {
            return (0,dist_index_esm/* themeGet */.R)("colors.".concat(row.color))({
                theme: theme
            }) === color;
        });
        return el && el.label ? el.label : "";
    }, [
        areaData,
        theme
    ]);
    var getValue = (0,react.useCallback)(function(param) {
        var color = param.color, data = param.data;
        if (color === "trasparent") return "";
        var el = areaData.find(function(row) {
            return (0,dist_index_esm/* themeGet */.R)("colors.".concat(row.color))({
                theme: theme
            }) === color;
        });
        if (el && el.id) {
            if (el && el.id.match(/revenue/)) {
                return (0,format_currency/* default */.Z)(el.currency, Number(data));
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* FormattedNumber */.BK, {
                value: data
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* FormattedNumber */.BK, {
            value: 0
        });
    }, [
        areaData,
        theme
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        x: "".concat(isRotate ? x - width : x + 5),
        y: "".concat(isRotate ? y - height / 2 - 15 : y - height / 2 + 15),
        width: width,
        height: height,
        viewBox: "0 0 ".concat(width, " ").concat(height),
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                isRotate: isRotate,
                stroke: "grey",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                        points: "10,25 0,35 10,45",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: width - 15,
                        height: height,
                        x: "9",
                        rx: "5",
                        ry: "5",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                    fill: (0,dist_index_esm/* themeGet */.R)("colors.grey_600")({
                        theme: theme
                    }),
                    style: {
                        whiteSpace: "pre",
                        fontFamily: "inherit",
                        fontSize: "16",
                        letterSpacing: "0px",
                        fontWeight: "bold"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                        x: "100",
                        y: "20",
                        children: moment_default()(activePoints[0].xName).format("YYYY-MM-DD")
                    })
                })
            }),
            activePoints.map(function(param, index) {
                var style = param.style, data = param.y;
                return areaData[index] && /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: "20",
                            r: "5",
                            fill: style.data.stroke,
                            cy: 40 + index * 20
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("text", {
                            fill: (0,dist_index_esm/* themeGet */.R)("colors.grey_600")({
                                theme: theme
                            }),
                            style: {
                                whiteSpace: "pre",
                                fontFamily: "inherit",
                                fontSize: "14",
                                letterSpacing: "0px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                                    x: "35",
                                    y: "45",
                                    dy: index * 20,
                                    children: "".concat(getLabel(style.data.stroke))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                                    textAnchor: "end",
                                    x: width - 15,
                                    y: "45",
                                    dy: index * 20,
                                    children: getValue({
                                        color: style.data.stroke,
                                        data: data
                                    })
                                })
                            ]
                        })
                    ]
                }, areaData[index].id);
            })
        ]
    });
}
/* harmony default export */ var label = (Label);

// EXTERNAL MODULE: ./src/theme/text/index.js
var theme_text = __webpack_require__(5799);
;// CONCATENATED MODULE: ./src/theme/charts/area-analytic/tabs.js

function tabs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n\n  ",
        "\n"
    ]);
    tabs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 8px;\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var WrapTab = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cec48197-0"
})(tabs_templateObject(), index_esm/* space */.Dh);
var TabBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-cec48197-1"
})(_templateObject1(), index_esm/* color */.$_, index_esm/* space */.Dh);
function AreaTabs(param) {
    var handleChangeTab = param.handleChangeTab, activeKey = param.activeKey, dataType = param.dataType;
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapTab, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabBtn, {
                type: "button",
                py: "s",
                px: "m",
                bg: activeKey === "amounts" ? "primary_100" : "grey_100",
                onClick: function() {
                    return handleChangeTab("amounts");
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                    fontSize: "h3",
                    lineHeight: "h3",
                    fontWeight: "medium",
                    color: activeKey === "amounts" ? "primary_500" : "grey_400",
                    textAlign: "center",
                    children: dataType === "usage_data" ? translations/* default */.Z[languageCode].usageChart : translations/* default */.Z[languageCode].revenueChart
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabBtn, {
                type: "button",
                py: "s",
                px: "m",
                bg: activeKey === "units" ? "primary_100" : "grey_100",
                onClick: function() {
                    return handleChangeTab("units");
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                    fontSize: "h3",
                    lineHeight: "h3",
                    fontWeight: "medium",
                    color: activeKey === "units" ? "primary_500" : "grey_400",
                    textAlign: "center",
                    children: dataType === "usage_data" ? translations/* default */.Z[languageCode].userChart : translations/* default */.Z[languageCode].quantityChart
                })
            })
        ]
    });
}
/* harmony default export */ var tabs = (AreaTabs);

;// CONCATENATED MODULE: ./src/theme/charts/area-analytic/index.js
/* eslint-disable no-nested-ternary */ 


function area_analytic_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  z-index: 999;\n\n  .VictoryContainer {\n    & > svg {\n      overflow: visible;\n    }\n  }\n\n  @media only screen and (max-width: 768px) {\n    .VictoryContainer {\n      user-select: auto !important;\n      touch-action: auto !important;\n    }\n  }\n"
    ]);
    area_analytic_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function area_analytic_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: flex;\n  /* The chart's own switch on one side and the totals on the other: on a phone\n     that was one row wider than the screen, with the figures cut off at the\n     right edge. Stacked below the first breakpoint, and each half wraps. */\n  flex-direction: column;\n  gap: ",
        "px;\n\n  .left {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    flex: 1;\n  }\n\n  .right {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    flex: 1;\n  }\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    gap: 0;\n\n    .left,\n    .right {\n      flex-wrap: nowrap;\n    }\n\n    .right {\n      justify-content: flex-end;\n    }\n  }\n"
    ]);
    area_analytic_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  .row {\n    display: flex;\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  white-space: nowrap;\n  text-transform: capitalize;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: flex;\n  align-items: center;\n\n  & > :before {\n    ",
        "\n\n    display: inline-block;\n    content: '';\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    margin-right: 6px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}













var area_analytic_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4acbffc7-0"
})(area_analytic_templateObject());
var Head = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4acbffc7-1"
})(area_analytic_templateObject1(), index_esm/* space */.Dh, (0,dist_index_esm/* themeGet */.R)("space.xs"), (0,dist_index_esm/* themeGet */.R)("breakpoints.0"));
var WrapValues = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4acbffc7-2"
})(_templateObject2());
var Value = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4acbffc7-3"
})(_templateObject3(), index_esm/* color */.$_, index_esm/* space */.Dh);
var Text = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-4acbffc7-4"
})(_templateObject4(), index_esm/* typography */.cp, index_esm/* color */.$_, index_esm/* space */.Dh);
var Legend = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4acbffc7-5"
})(_templateObject5());
var LegendLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-4acbffc7-6"
})(_templateObject6(), index_esm/* space */.Dh, index_esm/* color */.$_);
var WrapIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-4acbffc7-7"
})(_templateObject7(), index_esm/* color */.$_, index_esm/* space */.Dh);
// Helper function to clean data and ensure all values are finite numbers
var cleanData = function(data) {
    if (!Array.isArray(data)) return [];
    return data.filter(function(datum) {
        // Filter out any data points with invalid timestamps
        if (!datum.timestamp) return false;
        var timestamp = moment_default()(datum.timestamp);
        return timestamp.isValid();
    }).map(function(datum) {
        // Ensure y is a valid finite number
        var cleanY = typeof datum.y === "number" && Number.isFinite(datum.y) ? datum.y : 0;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, datum), {
            y: cleanY
        });
    });
};
function Area(param) {
    var title = param.title, temporaryRevenue = param.temporaryRevenue, repartitionCharge = param.repartitionCharge, chart = param.chart, isWithinRange = param.isWithinRange, chartHeight = param.chartHeight, titleMargin = param.titleMargin, handleChangeTab = param.handleChangeTab, activeKey = param.activeKey, dataType = param.dataType;
    var ref, ref1, ref2, ref3;
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    var width = (0,hooks/* useDimensions */.Bs)().width;
    var theme = (0,react.useContext)(styled_components_browser_esm/* ThemeContext */.Ni);
    var xAxisLength = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        if ((chart === null || chart === void 0 ? void 0 : chart.length) === 0) return 0;
        if (((ref = chart[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.length) <= 6) return 1;
        return ((ref2 = chart[0]) === null || ref2 === void 0 ? void 0 : ref2.data) ? Math.round(chart[0].data.length / 6) : 1;
    }, [
        chart
    ]);
    var maxAxisY = (0,react.useMemo)(function() {
        if (chart.length === 0) return 0;
        var maxAxis = chart.reduce(function(max, item) {
            var axisValue = typeof item.maxAxisY === "number" && Number.isFinite(item.maxAxisY) ? item.maxAxisY : 0;
            return Math.max(max, axisValue);
        }, 0);
        // Ensure the result is a valid finite number
        return typeof maxAxis === "number" && Number.isFinite(maxAxis) && maxAxis > 0 ? maxAxis : 100;
    }, [
        chart
    ]);
    var yAxisPadding = (0,react.useMemo)(function() {
        if (maxAxisY === 0) return 0;
        return maxAxisY.toString() ? -20 - maxAxisY.toString().length * 5 : -20;
    }, [
        maxAxisY
    ]);
    var PageWidth = (0,react.useMemo)(function() {
        // Ensure width is a valid finite number
        if (typeof width === "number" && Number.isFinite(width) && width > 0) {
            return width;
        }
        // Fallback to a reasonable default width if width is undefined, Infinity, or invalid
        return 800;
    }, [
        width
    ]);
    var ref4 = isWithinRange || {}, _sideDate = ref4.sideDate, sideDate = _sideDate === void 0 ? null : _sideDate, tmp = ref4.value, isSideDateActive = tmp === void 0 ? false : tmp;
    // console.log('isWithinRange', sideDate, sideDateParsed, isSideDateActive);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(area_analytic_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Head, {
                py: "s",
                px: "xs",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs, {
                        handleChangeTab: handleChangeTab,
                        activeKey: activeKey,
                        dataType: dataType
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "left",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                            fontSize: "h2",
                            lineHeight: "h2",
                            fontWeight: "bold",
                            color: "grey_400",
                            ml: titleMargin,
                            children: title
                        })
                    }),
                    temporaryRevenue && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "right",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapValues, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend, {
                                        children: chart.filter(function(el) {
                                            return !el.id.includes("repartition");
                                        }).map(function(el) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LegendLabel, {
                                                px: "xs",
                                                bg: el.color,
                                                mb: "0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                                    fontSize: "pSmall",
                                                    lineHeight: "pSmall",
                                                    fontWeight: "bold",
                                                    color: "grey_600",
                                                    children: el.label
                                                })
                                            }, el.color);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                            fontSize: "h2",
                                            lineHeight: "h2",
                                            fontWeight: "bold",
                                            color: ((ref = chart.find(function(el) {
                                                return !el.id.includes("repartition") && !el.id.includes("prev_");
                                            })) === null || ref === void 0 ? void 0 : ref.color) || "area_0",
                                            children: temporaryRevenue.value
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                                            pl: "s",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                                fontSize: "label",
                                                lineHeight: "label",
                                                fontWeight: "bold",
                                                color: temporaryRevenue.percent > 0 ? "lime_400" : temporaryRevenue.percent < 0 ? "red_400" : "grey_600",
                                                children: "".concat(temporaryRevenue.percent > 0 ? "+" : temporaryRevenue.percent < 0 ? "-" : "", " ").concat(Math.abs(temporaryRevenue.percent), "%")
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                            fontSize: "pLarge",
                                            lineHeight: "pLarge",
                                            fontWeight: "bold",
                                            color: ((ref1 = chart.find(function(el) {
                                                return !el.id.includes("repartition") && el.id.includes("prev_");
                                            })) === null || ref1 === void 0 ? void 0 : ref1.color) || "lime_400",
                                            children: temporaryRevenue.previousValue
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapIcon, {
                                            color: "primary_300",
                                            pl: "s",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_history/* default */.Z, {})
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    repartitionCharge && repartitionCharge.rawValue < 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "right",
                        style: {
                            marginLeft: "35px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapValues, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend, {
                                        children: chart.filter(function(el) {
                                            return el.id.includes("repartition");
                                        }).map(function(el) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LegendLabel, {
                                                px: "xs",
                                                bg: el.color,
                                                mb: "0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                                    fontSize: "pSmall",
                                                    lineHeight: "pSmall",
                                                    fontWeight: "bold",
                                                    color: "grey_600",
                                                    children: el.label
                                                })
                                            }, el.color);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                            fontSize: "h2",
                                            lineHeight: "h2",
                                            fontWeight: "bold",
                                            color: ((ref2 = chart.find(function(el) {
                                                return el.id.includes("repartition") && !el.id.includes("prev_");
                                            })) === null || ref2 === void 0 ? void 0 : ref2.color) || "orange_500",
                                            children: repartitionCharge.value
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                                            pl: "s",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                                fontSize: "label",
                                                lineHeight: "label",
                                                fontWeight: "bold",
                                                color: repartitionCharge.percent > 0 ? "lime_400" : repartitionCharge.percent < 0 ? "red_400" : "grey_600",
                                                children: "".concat(repartitionCharge.percent > 0 ? "+" : repartitionCharge.percent < 0 ? "-" : "", " ").concat(Math.abs(repartitionCharge.percent), "%")
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                            fontSize: "pLarge",
                                            lineHeight: "pLarge",
                                            fontWeight: "bold",
                                            color: ((ref3 = chart.find(function(el) {
                                                return el.id.includes("repartition") && el.id.includes("prev_");
                                            })) === null || ref3 === void 0 ? void 0 : ref3.color) || "orange_300",
                                            children: repartitionCharge.previousValue
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapIcon, {
                                            color: "primary_300",
                                            pl: "s",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_history/* default */.Z, {})
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(victory_chart/* VictoryChart */.k, {
                height: typeof chartHeight === "number" && Number.isFinite(chartHeight) && chartHeight > 0 ? chartHeight : 300,
                width: PageWidth,
                animate: {
                    duration: 1000
                },
                domainPadding: {
                    x: 0,
                    y: 30
                },
                containerComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(victory_voronoi_container/* default */.Z, {
                    voronoiBlacklist: [
                        "parent"
                    ],
                    voronoiDimension: "x",
                    labels: function() {
                        return " ";
                    },
                    labelComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(victory_tooltip/* default */.Z, {
                        cornerRadius: 4,
                        flyoutStyle: {
                            fill: "white",
                            stroke: "transparent"
                        },
                        style: {
                            fontSize: 13,
                            fontFamily: "inherit",
                            lineHeight: "20px",
                            fill: (0,dist_index_esm/* themeGet */.R)("colors.grey_600")({
                                theme: theme
                            })
                        },
                        flyoutComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(label, {
                            maxWidth: PageWidth,
                            data: chart
                        })
                    })
                }),
                padding: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 50
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(victory_axis/* VictoryAxis */.E, {
                        tickFormat: function(t, index) {
                            if (index % xAxisLength === 0) {
                                // Converti il timestamp in una data formattata
                                return moment_default()(t).format("MMM DD");
                            }
                            return "";
                        },
                        style: {
                            axis: {
                                stroke: "transparent"
                            },
                            tickLabels: {
                                fontFamily: "inherit",
                                fontSize: 13,
                                padding: 12,
                                angle: 35,
                                verticalAnchor: "end",
                                textAnchor: "start"
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(victory_axis/* VictoryAxis */.E, {
                        tickFormat: function(t) {
                            return t.toFixed(0);
                        },
                        dependentAxis: true,
                        style: {
                            grid: {
                                stroke: "grey",
                                strokeDasharray: "4, 8",
                                strokeWidth: 0.5
                            },
                            axis: {
                                stroke: "transparent"
                            },
                            tickLabels: {
                                fontFamily: "inherit",
                                textAnchor: "end",
                                fontSize: 13,
                                padding: yAxisPadding
                            }
                        }
                    }),
                    chart.map(function(el) {
                        // Divide i dati in base alla sideDate
                        var sideDateTime = sideDate ? moment_default()(sideDate).endOf("day").utc().startOf("day").format() : moment_default()("2100-01-01").format();
                        var dataBeforeSideDate = cleanData(el.data.filter(function(datum) {
                            return moment_default()(datum.timestamp).isSameOrBefore(sideDateTime);
                        }));
                        var dataAfterSideDate = cleanData(el.data.filter(function(datum) {
                            return moment_default()(datum.timestamp).isSameOrAfter(sideDateTime);
                        }));
                        if (el.id.match(/prev_/)) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(victory_group/* VictoryGroup */.G, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(victory_line/* VictoryLine */.j, {
                                        style: {
                                            data: {
                                                stroke: (0,dist_index_esm/* themeGet */.R)("colors.".concat(el.color))({
                                                    theme: theme
                                                }),
                                                strokeWidth: 3,
                                                opacity: el.opacity || 0.65
                                            }
                                        },
                                        data: cleanData(dataBeforeSideDate),
                                        x: "timestamp",
                                        interpolation: "natural",
                                        labels: function() {
                                            return " ";
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(victory_line/* VictoryLine */.j, {
                                        style: {
                                            data: {
                                                stroke: (0,dist_index_esm/* themeGet */.R)("colors.".concat(el.color))({
                                                    theme: theme
                                                }),
                                                strokeWidth: 3,
                                                opacity: 0.4
                                            }
                                        },
                                        data: cleanData(dataAfterSideDate),
                                        x: "timestamp",
                                        interpolation: "natural",
                                        labels: function() {
                                            return " ";
                                        }
                                    })
                                ]
                            }, "".concat(el.id));
                        }
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(victory_group/* VictoryGroup */.G, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(victory_area/* VictoryArea */.b, {
                                    style: {
                                        data: {
                                            fill: (0,dist_index_esm/* themeGet */.R)("colors.".concat(el.color))({
                                                theme: theme
                                            }),
                                            stroke: (0,dist_index_esm/* themeGet */.R)("colors.".concat(el.color))({
                                                theme: theme
                                            }),
                                            opacity: el.opacity || 0.65
                                        }
                                    },
                                    data: dataBeforeSideDate,
                                    x: "timestamp",
                                    interpolation: "natural"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(victory_area/* VictoryArea */.b, {
                                    style: {
                                        data: {
                                            fill: (0,dist_index_esm/* themeGet */.R)("colors.".concat(el.color))({
                                                theme: theme
                                            }),
                                            stroke: (0,dist_index_esm/* themeGet */.R)("colors.".concat(el.color))({
                                                theme: theme
                                            }),
                                            opacity: 0.4
                                        }
                                    },
                                    data: dataAfterSideDate,
                                    x: "timestamp",
                                    interpolation: "natural"
                                })
                            ]
                        }, "".concat(el.id));
                    }),
                    isSideDateActive && sideDate && chart && chart.length > 0 && chart[0].data && chart[0].data.length > 0 && function() {
                        var firstDate = moment_default()(chart[0].data[0].timestamp);
                        var lastDate = moment_default()(chart[0].data[chart[0].data.length - 1].timestamp);
                        var sideDateMoment = moment_default()(sideDate);
                        // Mostra la sideDate solo se è nel range dei dati
                        if (sideDateMoment.isBetween(firstDate, lastDate, null, "[]")) {
                            // Converti la sideDate nel formato corretto per VictoryChart
                            var sideDateForChart = sideDateMoment.format("YYYY-MM-DDTHH:mm:ss[Z]");
                            // Ensure maxAxisY is valid before using it
                            var validMaxAxisY = typeof maxAxisY === "number" && Number.isFinite(maxAxisY) && maxAxisY > 0 ? maxAxisY : 100;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(victory_line/* VictoryLine */.j, {
                                data: cleanData([
                                    {
                                        timestamp: sideDateForChart,
                                        x: sideDateForChart,
                                        y: 0
                                    },
                                    {
                                        timestamp: sideDateForChart,
                                        x: sideDateForChart,
                                        y: validMaxAxisY
                                    }, 
                                ]),
                                style: {
                                    data: {
                                        stroke: "red",
                                        strokeDasharray: "4",
                                        strokeWidth: 2
                                    }
                                },
                                labels: function() {
                                    return translations/* default */.Z[languageCode].sideDateText;
                                },
                                labelComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(victory_tooltip/* default */.Z, {
                                    constrainToVisibleArea: true,
                                    flyoutStyle: {
                                        stroke: "red",
                                        strokeWidth: 1,
                                        fill: "white"
                                    },
                                    flyoutPadding: 10,
                                    orientation: "top"
                                })
                            });
                        }
                        return null;
                    }()
                ]
            })
        ]
    });
}
/* harmony default export */ var area_analytic = (Area);


/***/ }),

/***/ 87504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ history; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function history() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M15.6276 3.27156C16.3675 4.00957 16.9568 4.8844 17.3628 5.84736C17.7855 6.84457 18.0022 7.91695 18 9.00006C18.002 10.6144 17.5198 12.1923 16.6158 13.5298C15.7374 14.8323 14.4996 15.8516 13.0527 16.4637C12.0545 16.8833 10.9827 17.0996 9.89999 17.1C8.83632 17.1007 7.78298 16.8914 6.8003 16.4844C5.81762 16.0773 4.92491 15.4803 4.1733 14.7277L5.44589 13.4551C5.73184 13.7406 6.04435 13.9983 6.37919 14.2246C7.06001 14.6851 7.82486 15.0072 8.63009 15.1722C9.46849 15.3419 10.3324 15.3419 11.1708 15.1722C11.5758 15.089 11.9716 14.966 12.3525 14.8051C13.1002 14.487 13.78 14.0284 14.355 13.4542C14.6403 13.1698 14.8986 12.8557 15.1236 12.5218C15.5851 11.8407 15.9075 11.0751 16.0722 10.2691C16.242 9.43036 16.242 8.56615 16.0722 7.72746C15.7347 6.09098 14.7612 4.6555 13.3656 3.73656C11.9701 2.81763 10.2668 2.49045 8.63009 2.82696C7.8247 2.99382 7.05954 3.31602 6.37739 3.77556C5.70685 4.22962 5.1292 4.80758 4.6755 5.47836C3.97211 6.51792 3.59741 7.74489 3.6 9.00006L3.6009 9.02256H5.39999L2.7 12.6001L0 9.02256H1.8009L1.8 9.00006C1.79849 7.91673 2.0152 6.84421 2.4372 5.84646C2.8452 4.88513 3.4343 4.01126 4.1724 3.27246C5.29152 2.15016 6.7164 1.38231 8.26919 1.06476C9.34595 0.8456 10.4558 0.8456 11.5326 1.06476C13.0839 1.38435 14.5076 2.15157 15.6276 3.27156Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9 9.8999V5.3999H10.8V8.0999H13.5V9.8999H9Z",
                fill: "currentColor"
            })
        ]
    });
}


/***/ })

}]);